import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin } from 'rxjs';
import { UserService } from './core/user/user.service';
import { BillService } from './core/bill/bill.service';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const userService = inject(UserService);
    const billService = inject(BillService);
    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        userService.getUser(),
        navigationService.get(),
        // billService.getIncompeleteCount()
    ]);
};
